/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { ApiResponse, apiClient, v3Client } from '@api/apiClient';
import { AutocompleteProps } from '@components/Autocomplete/types';
import { AxiosResponse } from 'axios';
import { get } from 'lodash';

import { Autocomplete } from './AutoComplete';

export const NewAutoComplete = <T,>(props: AutocompleteProps<T>) => {
  const fetchData = async (
    searchQuery: string,
    setSearchResults: (items: T[]) => void,
    onError?: (message: string) => void,
  ) => {
    let response: AxiosResponse<ApiResponse<T[]>> | { data: T[] } | T[];
    let items;
    if (props.version === 'v3') {
      const trimmedQuery = searchQuery.trimStart();
      const v3SearchQuery = /[+]/.test(trimmedQuery)
        ? encodeURIComponent(trimmedQuery)
        : trimmedQuery;

      response = await v3Client.get<string, { data: T[] } | T[]>(
        `${props.endpoint}${v3SearchQuery}`,
      );
      if ('data' in response) {
        items = response.data;
      } else {
        items = response;
      }

      setSearchResults(items);
    } else {
      try {
        response = await apiClient.get<string, AxiosResponse<ApiResponse<T[]>>>(
          `${props.endpoint}=${encodeURIComponent(searchQuery.trimStart())}`,
        );

        // TODO: The type of `response` here need to be handled properly.
        // We shouldn't have to guess what response is.
        if ('value' in response) {
          items = response.value as T[];
        } else {
          response = await apiClient.get<
            string,
            AxiosResponse<ApiResponse<T[]>>
          >(`${props.endpoint}=${searchQuery.trimStart()}`);

          // TODO: The type of `response` here need to be handled properly.
          // We shouldn't have to guess what response is.
          if ('value' in response) {
            items = response.value as T[];
          } else {
            items = response as unknown as T[];
          }
        }

        // When exactMatchField is set, only surface results whose field
        // value exactly matches the typed query (case-insensitive, trimmed)
        // rather than whatever partial match the endpoint itself returns.
        const matchedItems = props.exactMatchField
          ? items.filter(
              (item) =>
                String(get(item as object, props.exactMatchField!, ''))
                  .trim()
                  .toLowerCase() === searchQuery.trim().toLowerCase(),
            )
          : items;

        // As per requirements, we only need to show the first 50 results
        // in our autocomplete list. The limit can be tweaked, but keep in
        // mind that the list absolutely needs to be limited, otherwise it
        // can crash the app or cause performance issues.
        setSearchResults(matchedItems.slice(0, 50));
      } catch (error) {
        onError?.('Search failed. Please try again.');
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
  };
  const getStaticData = (
    searchQuery: string,
    setSearchResults: (items: T[]) => void,
  ) => {
    if (!Boolean(searchQuery)) {
      props.staticItemList && setSearchResults(props.staticItemList);
    } else {
      const items = (props.staticItemList || []).filter((item) => {
        return get(item as object, 'value', '')
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
      });
      setSearchResults(items);
    }
  };
  return (
    <Autocomplete
      fetchData={Boolean(props.isStatic) ? getStaticData : fetchData}
      {...props}
    />
  );
};
